<template>
  <el-dialog
    :visible="true"
    width="560px"
    custom-class="group-weighing-dialog cooked-weights-theme"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @update:visible="$emit('close')"
  >
    <template v-slot:title>
      <div class="group-weighing-dialog__header">
        <span class="group-weighing-dialog__title">{{ group.subgroup_name }}</span>
        <group-status-chip v-if="isShortWeighed" :group="group" />
      </div>
    </template>
    <group-weighing-panel
      :date="date"
      :group="group"
      @group-updated="onGroupUpdated"
      @reload-requested="$emit('reload-requested')"
    />
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import GroupStatusChip from './GroupStatusChip.vue'
import GroupWeighingPanel from './GroupWeighingPanel.vue'
import { STATUS } from '../cookedWeightsConstants'

export default {
  name: 'GroupWeighingDialog',
  components: {
    [Dialog.name]: Dialog,
    GroupStatusChip,
    GroupWeighingPanel
  },
  props: {
    date: {
      type: String,
      required: true
    },
    group: {
      type: Object,
      required: true
    }
  },
  computed: {
    isShortWeighed () {
      return this.group.status === STATUS.SHORT_WEIGHED
    }
  },
  methods: {
    onGroupUpdated (updatedGroup) {
      this.$emit('group-updated', updatedGroup)
      if (updatedGroup.status === STATUS.WEIGHED) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style>
.group-weighing-dialog {
  border-radius: var(--radius);
  box-shadow: 0 4px 16px rgba(31, 41, 51, 0.16);
}

.group-weighing-dialog .el-dialog__header {
  padding: 16px 64px 16px 24px;
  border-bottom: 1px solid var(--line);
}

.group-weighing-dialog .el-dialog__body {
  padding: 0 24px 16px;
}

.group-weighing-dialog__header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.group-weighing-dialog__title {
  font-size: var(--font-base);
  font-weight: 700;
  color: var(--text-strong);
}


.group-weighing-dialog .el-dialog__headerbtn {
  top: 10px;
  right: 10px;
  width: 44px;
  height: 44px;
  font-size: 20px;
}

@media (max-width: 576px) {
  .group-weighing-dialog {
    width: 92% !important;
  }
}
</style>
